export const translations = {
  en: {
    nav: {
      home: "Home",
      shop: "Shop",
      newCollection: "New Collection",
      about: "About",
      lookbook: "Lookbook",
      community: "Community",
      journal: "Journal",
      contact: "Contact",
      cart: "Cart",
    },
    common: {
      shopCollection: "Shop the Collection",
      discover: "Discover",
      explore: "Explore",
      readMore: "Read more",
      learnMore: "Learn more",
      from: "from",
      addToCart: "Add to bag",
      addedToCart: "Added to your bag",
      size: "Size",
      color: "Color",
      selectSize: "Select a size",
      selectColor: "Select a color",
      sizeGuide: "Size guide",
      newIn: "New in",
      featured: "Featured",
      details: "Details",
      materials: "Materials & Care",
      shipping: "Shipping & Returns",
      shippingText: "Complimentary express shipping on all orders. Returns within 30 days.",
      youMayAlsoLike: "Complete the look",
      back: "Back",
      continueShopping: "Continue shopping",
      proceedToCheckout: "Proceed to checkout",
      subtotal: "Subtotal",
      total: "Total",
      shippingNote: "Shipping calculated at checkout",
      emptyCart: "Your bag is empty",
      emptyCartCta: "Start with our signature collection",
      remove: "Remove",
      qty: "Qty",
      email: "Email",
      name: "Name",
      message: "Message",
      subject: "Subject",
      send: "Send",
      submit: "Submit",
      sending: "Sending…",
      thankYou: "Thank you",
      newsletterPlaceholder: "Enter your email",
      newsletterSubscribe: "Subscribe",
      newsletterSuccess: "Welcome to MALY",
      newsletterError: "Please enter a valid email",
      processing: "Processing…",
      paymentSuccess: "Payment successful",
      paymentSuccessText: "Your order is confirmed. Look for an email shortly.",
      paymentPending: "Payment is being processed…",
      paymentFailed: "Payment was not completed",
      backToShop: "Back to shop",
    },
    hero: {
      overline: "The First Drop · Autumn Edit",
      title1: "Golf Fashion.",
      title2: "Reinvented.",
      sub: "Sleeveless silhouettes. High-waist tailoring. Designed for women who refuse to choose between performance and presence.",
      cta: "Shop the Collection",
      secondaryCta: "View Lookbook",
    },
    marquee: ["Designed for Women", "Built for Confidence", "Made in Italy", "Performance Luxury", "The Country Club Reimagined"],
    manifesto: {
      overline: "The MALY Manifesto",
      headline: "Golf fashion shouldn't hide women. It should sculpt them.",
      body: "We exist for the woman who walks onto the course already certain of who she is. We design for her swing, her shape, her standards. Performance is the floor — never the ceiling.",
      cta: "Read our story",
    },
    featured: {
      overline: "The Signatures",
      headline: "Four pieces. Endless rotations.",
      sub: "A capsule built for the modern golfer — engineered in Italian performance fabrics, cut to celebrate every silhouette.",
    },
    lookbookCta: {
      overline: "Autumn / Winter Edit",
      headline: "Country club, reimagined.",
      sub: "Editorial photography from the driving range to the dinner reservation. See the collection in motion.",
      cta: "Enter the Lookbook",
    },
    valuesSection: {
      overline: "What we stand for",
      headline: "Premium. Modern. Built for her.",
      values: [
        { title: "Italian Craft", body: "Engineered in northern Italy with mills that supply the world's leading luxury houses." },
        { title: "Performance Luxe", body: "Four-way stretch. UPF 50+. Moisture-wicking. Dressed up enough for the club lounge." },
        { title: "Made for Her", body: "Fit-tested on real women, real bodies, real swings. No more shrink-it-and-pink-it." },
        { title: "Quiet Confidence", body: "We don't shout. The garments do." },
      ],
    },
    journalPreview: {
      overline: "The Journal",
      headline: "Style notes & inside stories.",
      cta: "All stories",
      articles: [
        { tag: "Editorial", title: "Why golf fashion needs a feminine reset", excerpt: "On the brands that forgot women exist beyond a shrunken polo." },
        { tag: "Craft", title: "Inside our Italian mill", excerpt: "Behind every stitch: 60 years of textile mastery and quiet obsession." },
        { tag: "Community", title: "The women rewriting the club", excerpt: "Six golfers, six cities, one unapologetic point of view." },
      ],
    },
    community: {
      overline: "@MALYofficial",
      headline: "The community.",
      sub: "Tagged by women who play on their terms.",
      cta: "Follow us",
    },
    footer: {
      newsletterHead: "Subscribe to the MALY world",
      newsletterSub: "First access to new drops, lookbooks and atelier invitations.",
      explore: "Explore",
      help: "Help",
      legal: "Legal",
      contact: "Contact",
      shipping: "Shipping",
      returns: "Returns",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      imprint: "Imprint",
      rights: "© MALY. All rights reserved.",
      paymentSecure: "Secure checkout. Encrypted at every step.",
    },
    about: {
      overline: "About MALY",
      hero: "We exist to give women back their power on the course.",
      sub: "MALY is not another golf brand. It is a luxury fashion house that happens to live on the fairway.",
      missionTitle: "Our Mission",
      mission: [
        "Golf fashion should not hide women — it should sculpt them.",
        "It should give confidence, not erase it.",
        "It should perform without compromise.",
        "It should look modern, feel luxurious, move with her.",
      ],
      storyTitle: "The story",
      storyBody: "MALY was born from a closet full of compromises. Performance pieces that swallowed every curve. Polos cut for a body that wasn't ours. Skirts that climbed with every swing. We built MALY for the woman who refuses to choose between athletic and elegant — and who has the standards of a Milan editor.",
      valuesTitle: "What we stand for",
    },
    lookbook: {
      overline: "Autumn / Winter — Volume 01",
      headline: "Country Club. Reimagined.",
      sub: "Shot between the Côte d'Azur, an English country estate and a Marrakech driving range. This is golf, but not as you've seen it.",
    },
    contact: {
      overline: "Contact",
      headline: "Get in touch.",
      sub: "Press, partnerships, custom requests or simply a question. We respond within 24–48 hours.",
      thanks: "Thank you. We've received your message.",
      hello: "Hello@",
      pressTitle: "Press",
      pressMail: "press@maly.com",
      atelierTitle: "Atelier",
      atelierMail: "atelier@maly.com",
      serviceTitle: "Client Service",
      serviceMail: "care@maly.com",
    },
    journal: {
      overline: "The Journal",
      headline: "Notes from the atelier.",
      sub: "Style, craft, and the women rewriting the rules of golf.",
    },
    shop: {
      overline: "The Collection",
      headline: "Shop everything.",
      sub: "Four signature pieces. Each one engineered to be the most flattering thing you own.",
      filters: "Filter",
      sort: "Sort",
    },
    cart: {
      overline: "Your bag",
      headline: "The collection, curated by you.",
    },
  },
  de: {
    nav: {
      home: "Start",
      shop: "Shop",
      newCollection: "Neue Kollektion",
      about: "Über",
      lookbook: "Lookbook",
      community: "Community",
      journal: "Journal",
      contact: "Kontakt",
      cart: "Warenkorb",
    },
    common: {
      shopCollection: "Kollektion entdecken",
      discover: "Entdecken",
      explore: "Erkunden",
      readMore: "Weiterlesen",
      learnMore: "Mehr erfahren",
      from: "ab",
      addToCart: "In den Warenkorb",
      addedToCart: "Zum Warenkorb hinzugefügt",
      size: "Größe",
      color: "Farbe",
      selectSize: "Größe wählen",
      selectColor: "Farbe wählen",
      sizeGuide: "Größentabelle",
      newIn: "Neu",
      featured: "Highlights",
      details: "Details",
      materials: "Material & Pflege",
      shipping: "Versand & Rückgabe",
      shippingText: "Kostenloser Express-Versand. 30 Tage Rückgaberecht.",
      youMayAlsoLike: "Vervollständige den Look",
      back: "Zurück",
      continueShopping: "Weiter einkaufen",
      proceedToCheckout: "Zur Kasse",
      subtotal: "Zwischensumme",
      total: "Summe",
      shippingNote: "Versand wird beim Checkout berechnet",
      emptyCart: "Dein Warenkorb ist leer",
      emptyCartCta: "Beginne mit unseren Signature-Pieces",
      remove: "Entfernen",
      qty: "Anz.",
      email: "E-Mail",
      name: "Name",
      message: "Nachricht",
      subject: "Betreff",
      send: "Senden",
      submit: "Absenden",
      sending: "Wird gesendet…",
      thankYou: "Vielen Dank",
      newsletterPlaceholder: "Deine E-Mail",
      newsletterSubscribe: "Anmelden",
      newsletterSuccess: "Willkommen bei MALY",
      newsletterError: "Bitte gültige E-Mail eingeben",
      processing: "Wird verarbeitet…",
      paymentSuccess: "Zahlung erfolgreich",
      paymentSuccessText: "Deine Bestellung ist bestätigt. Eine E-Mail folgt in Kürze.",
      paymentPending: "Zahlung wird verarbeitet…",
      paymentFailed: "Zahlung wurde nicht abgeschlossen",
      backToShop: "Zurück zum Shop",
    },
    hero: {
      overline: "The First Drop · Herbst Edit",
      title1: "Golf Fashion.",
      title2: "Neu gedacht.",
      sub: "Ärmellose Silhouetten. High-Waist Schnitte. Für Frauen, die sich nicht zwischen Performance und Präsenz entscheiden.",
      cta: "Kollektion entdecken",
      secondaryCta: "Lookbook ansehen",
    },
    marquee: ["Designed for Women", "Built for Confidence", "Made in Italy", "Performance Luxury", "Der Country Club neu gedacht"],
    manifesto: {
      overline: "Das MALY Manifest",
      headline: "Golfmode soll Frauen nicht verstecken. Sie soll sie modellieren.",
      body: "Wir designen für die Frau, die den Platz betritt und bereits weiß, wer sie ist. Für ihren Schwung. Ihre Silhouette. Ihre Standards. Performance ist der Boden — niemals die Decke.",
      cta: "Unsere Geschichte",
    },
    featured: {
      overline: "Die Signatures",
      headline: "Vier Pieces. Unendliche Looks.",
      sub: "Eine Capsule für die moderne Golferin — italienische Performance-Stoffe, kompromisslose Schnitte, jede Silhouette gefeiert.",
    },
    lookbookCta: {
      overline: "Herbst / Winter Edit",
      headline: "Country Club. Neu interpretiert.",
      sub: "Editorial-Fotografie von der Driving Range bis zur Dinner-Reservierung. Die Kollektion in Bewegung.",
      cta: "Zum Lookbook",
    },
    valuesSection: {
      overline: "Wofür wir stehen",
      headline: "Premium. Modern. Für sie gebaut.",
      values: [
        { title: "Italian Craft", body: "Gefertigt in Norditalien — in Webereien, die die führenden Luxushäuser der Welt beliefern." },
        { title: "Performance Luxe", body: "Vier-Wege-Stretch. UPF 50+. Feuchtigkeitsableitend. Elegant genug für die Club Lounge." },
        { title: "Für sie gemacht", body: "Passform getestet an echten Frauen, echten Körpern, echten Schwüngen. Kein shrink-it-and-pink-it." },
        { title: "Quiet Confidence", body: "Wir schreien nicht. Die Pieces tun es." },
      ],
    },
    journalPreview: {
      overline: "Das Journal",
      headline: "Style Notes & Insider Storys.",
      cta: "Alle Beiträge",
      articles: [
        { tag: "Editorial", title: "Warum Golfmode einen feminin reset braucht", excerpt: "Über die Marken, die vergaßen, dass Frauen mehr sind als ein eingegangenes Polo." },
        { tag: "Craft", title: "In unserer italienischen Manufaktur", excerpt: "Hinter jedem Stich: 60 Jahre Textil-Meisterschaft und stille Obsession." },
        { tag: "Community", title: "Die Frauen, die den Club neu schreiben", excerpt: "Sechs Golferinnen, sechs Städte, eine kompromisslose Haltung." },
      ],
    },
    community: {
      overline: "@MALYofficial",
      headline: "Die Community.",
      sub: "Markiert von Frauen, die zu ihren Bedingungen spielen.",
      cta: "Folge uns",
    },
    footer: {
      newsletterHead: "Werde Teil der MALY Welt",
      newsletterSub: "Erster Zugang zu neuen Drops, Lookbooks und Atelier-Einladungen.",
      explore: "Entdecken",
      help: "Hilfe",
      legal: "Rechtliches",
      contact: "Kontakt",
      shipping: "Versand",
      returns: "Retouren",
      privacy: "Datenschutz",
      terms: "AGB",
      imprint: "Impressum",
      rights: "© MALY. Alle Rechte vorbehalten.",
      paymentSecure: "Sicherer Checkout. Verschlüsselt bei jedem Schritt.",
    },
    about: {
      overline: "Über MALY",
      hero: "Wir geben Frauen ihre Stärke auf dem Platz zurück.",
      sub: "MALY ist keine weitere Golfmarke. Es ist ein Luxus-Modehaus, das zufällig auf dem Fairway lebt.",
      missionTitle: "Unsere Mission",
      mission: [
        "Golfmode soll Frauen nicht verstecken — sie soll sie modellieren.",
        "Sie soll Selbstbewusstsein geben, nicht nehmen.",
        "Sie soll kompromisslos performen.",
        "Sie soll modern aussehen, sich luxuriös anfühlen und mit ihr bewegen.",
      ],
      storyTitle: "Die Geschichte",
      storyBody: "MALY wurde aus einem Kleiderschrank voller Kompromisse geboren. Performance-Pieces, die jede Kurve verschluckten. Polos, geschnitten für Körper, die nicht unsere waren. Röcke, die mit jedem Schwung hochrutschten. Wir bauten MALY für die Frau, die sich nicht zwischen sportlich und elegant entscheidet — und die die Standards einer Mailänder Editor-in-Chief hat.",
      valuesTitle: "Was uns ausmacht",
    },
    lookbook: {
      overline: "Herbst / Winter — Volume 01",
      headline: "Country Club. Neu interpretiert.",
      sub: "Aufgenommen zwischen der Côte d'Azur, einem englischen Landgut und einer Marrakesch Driving Range. Das ist Golf — aber nicht so, wie du es kennst.",
    },
    contact: {
      overline: "Kontakt",
      headline: "Sprich mit uns.",
      sub: "Presse, Partnerschaften, Sonderwünsche oder einfach eine Frage. Wir antworten innerhalb 24–48 Stunden.",
      thanks: "Danke. Wir haben deine Nachricht erhalten.",
      hello: "Hello@",
      pressTitle: "Presse",
      pressMail: "press@maly.com",
      atelierTitle: "Atelier",
      atelierMail: "atelier@maly.com",
      serviceTitle: "Client Service",
      serviceMail: "care@maly.com",
    },
    journal: {
      overline: "Das Journal",
      headline: "Notizen aus dem Atelier.",
      sub: "Style, Craft und die Frauen, die die Regeln des Golfsports neu schreiben.",
    },
    shop: {
      overline: "Die Kollektion",
      headline: "Alle Pieces.",
      sub: "Vier Signature-Pieces. Jedes konstruiert, um das schmeichelhafteste Teil deines Schranks zu werden.",
      filters: "Filter",
      sort: "Sortieren",
    },
    cart: {
      overline: "Dein Warenkorb",
      headline: "Die Kollektion, von dir kuratiert.",
    },
  },
};

export const journalArticles = {
  en: [
    {
      tag: "Editorial",
      title: "Why golf fashion needs a feminine reset",
      excerpt: "On the brands that forgot women exist beyond a shrunken polo, and the rise of a new aesthetic.",
      image: "https://images.unsplash.com/photo-1695418423426-b1e647262e73",
      date: "Nov 2025",
      readTime: "6 min",
    },
    {
      tag: "Craft",
      title: "Inside our Italian mill",
      excerpt: "Behind every stitch: 60 years of textile mastery and quiet obsession.",
      image: "https://images.pexels.com/photos/19590840/pexels-photo-19590840.jpeg",
      date: "Nov 2025",
      readTime: "8 min",
    },
    {
      tag: "Community",
      title: "The women rewriting the club",
      excerpt: "Six golfers, six cities, one unapologetic point of view on the future of the sport.",
      image: "https://images.pexels.com/photos/37990557/pexels-photo-37990557.jpeg",
      date: "Oct 2025",
      readTime: "5 min",
    },
    {
      tag: "Style",
      title: "From driving range to dinner reservation",
      excerpt: "Five ways to wear our signature pieces from morning tee time to evening cocktails.",
      image: "https://images.unsplash.com/photo-1500932334442-8761ee4810a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxnb2xmfGVufDB8fHx8MTc4MjY1MzcyM3ww&ixlib=rb-4.1.0&q=85",
      date: "Oct 2025",
      readTime: "4 min",
    },
  ],
  de: [
    {
      tag: "Editorial",
      title: "Warum Golfmode einen feminin reset braucht",
      excerpt: "Über die Marken, die vergaßen, dass Frauen mehr sind als ein eingegangenes Polo — und der Aufstieg einer neuen Ästhetik.",
      image: "https://images.unsplash.com/photo-1695418423426-b1e647262e73",
      date: "Nov 2025",
      readTime: "6 Min",
    },
    {
      tag: "Craft",
      title: "In unserer italienischen Manufaktur",
      excerpt: "Hinter jedem Stich: 60 Jahre Textil-Meisterschaft und stille Obsession.",
      image: "https://images.pexels.com/photos/19590840/pexels-photo-19590840.jpeg",
      date: "Nov 2025",
      readTime: "8 Min",
    },
    {
      tag: "Community",
      title: "Die Frauen, die den Club neu schreiben",
      excerpt: "Sechs Golferinnen, sechs Städte, eine kompromisslose Haltung zur Zukunft des Sports.",
      image: "https://images.pexels.com/photos/37990557/pexels-photo-37990557.jpeg",
      date: "Okt 2025",
      readTime: "5 Min",
    },
    {
      tag: "Style",
      title: "Von der Driving Range zur Dinner-Reservierung",
      excerpt: "Fünf Wege, unsere Signature-Pieces vom morgendlichen Tee bis zum Abend-Cocktail zu tragen.",
      image: "https://images.unsplash.com/photo-1500932334442-8761ee4810a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxnb2xmfGVufDB8fHx8MTc4MjY1MzcyM3ww&ixlib=rb-4.1.0&q=85",
      date: "Okt 2025",
      readTime: "4 Min",
    },
  ],
};

export const communityImages = [
  "https://images.unsplash.com/photo-1695418423426-b1e647262e73",
  "https://images.pexels.com/photos/37990557/pexels-photo-37990557.jpeg",
  "https://images.pexels.com/photos/19590840/pexels-photo-19590840.jpeg",
  "https://images.pexels.com/photos/14760649/pexels-photo-14760649.jpeg",
  "https://images.unsplash.com/photo-1500932334442-8761ee4810a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxnb2xmfGVufDB8fHx8MTc4MjY1MzcyM3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1632946269126-0f8edbe8b068?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxnb2xmfGVufDB8fHx8MTc4MjY1MzcyM3ww&ixlib=rb-4.1.0&q=85",
];

export const lookbookImages = [
  { src: "https://images.unsplash.com/photo-1695418423426-b1e647262e73", caption: { en: "Look 01 — The Tailored Walk", de: "Look 01 — Der Tailored Walk" }, span: "tall" },
  { src: "https://images.pexels.com/photos/37990557/pexels-photo-37990557.jpeg", caption: { en: "Look 02 — Cream on Cream", de: "Look 02 — Cream on Cream" }, span: "wide" },
  { src: "https://images.pexels.com/photos/19590840/pexels-photo-19590840.jpeg", caption: { en: "Look 03 — The Stacked Trouser", de: "Look 03 — Die Stacked-Hose" }, span: "tall" },
  { src: "https://images.pexels.com/photos/14760649/pexels-photo-14760649.jpeg", caption: { en: "Look 04 — Sunset at the Range", de: "Look 04 — Sunset Range" }, span: "wide" },
  { src: "https://images.unsplash.com/photo-1500932334442-8761ee4810a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxnb2xmfGVufDB8fHx8MTc4MjY1MzcyM3ww&ixlib=rb-4.1.0&q=85", caption: { en: "Look 05 — The Editorial Skort", de: "Look 05 — Editorial Skort" }, span: "tall" },
  { src: "https://images.unsplash.com/photo-1632946269126-0f8edbe8b068?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxnb2xmfGVufDB8fHx8MTc4MjY1MzcyM3ww&ixlib=rb-4.1.0&q=85", caption: { en: "Look 06 — Off Duty", de: "Look 06 — Off Duty" }, span: "wide" },
];
